import { initializeApp } from "firebase/app";

import { getMessaging } from "firebase/messaging";


//Firebase Config values imported from .env file
const firebaseConfig = {
    apiKey: "AIzaSyB_a00O60ZYwDDTuQLDrJP9l7h8B0Erwyc",
    authDomain: "amexa-1e72e.firebaseapp.com",
    projectId: "amexa-1e72e",
    storageBucket: "amexa-1e72e.firebasestorage.app",
    messagingSenderId: "1020224981888",
    appId: "1:1020224981888:web:b5a8ce1d55241da7604f65",
    measurementId: "G-LQFQ359PB0"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Messaging service
export const messaging = getMessaging(app);
export const VAPID_KEY = 'BHUgdydlhLQxBiOiIA0u-DPAbTQnkz8YK9TQ2bUnpHh4g3Tflch6DGICWJCuNOD2O8s0kvLnCCWXktVfUQGvw70';